import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TemplateFormSchema } from '@models';
import { SmartFormTemplateService } from '@services';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SmartFormTemplateMockService implements SmartFormTemplateService {
  private http = inject(HttpClient);

  private url = './assets/ui-lib/smart-form.template.json';

  getTemplate(
    templateId: string,
    version: number
  ): Observable<TemplateFormSchema | null> {
    return this.http.get<TemplateFormSchema[]>(this.url).pipe(
      map(templates => {
        const template = templates.find(
          t => t.templateId === templateId && t.version === version
        );

        return template ?? null;
      })
    );
  }
}
